import Home from 'pages/blog/page';

const NbaBlogPage = () => <Home sportCategory="nba" />;
export default NbaBlogPage;
